import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { JSONRpc } from './service-jsonrpc';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
//import moment = require('moment');
import * as  moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class ParameterService {
  cacheListStatusDossier: any[];
  cacheListStateDossier: any[];
  cacheListZoneDossier: any[];

  constructor(
    private http: HttpClient
  ) {}

  getDemandesWithForms(): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.parametre:demande",
      params: {
          options:  {
              forms: true
            }
      }
    });
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }

  getPages(): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.parametre:page",
      params: {
        options: {
          
        }
      }
    });
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
  }

  getContactTypes(): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.parametre:contact",
      params: {
      }
    });
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);

  }
  
  getZoneTypes(): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.parametre:zonestype",
      params: {
      }
    });
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);

  }
  
  getCourrierList(): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.parametre:courrier",
      params: {
      }
    });
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);

  }
  
  getFormulaireList( _options: any = []): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.parametre:formulaire",
      params: {
		options: _options
      }
    });
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);

  }
  
  getDocumentList(): Observable<any> {
    let rpcMethod = new JSONRpc({
      jsonrpc : "2.0",
      method:"webservice.parametre:document",
      params: {
      }
    });
    return this.http.post<JSONRpc>(environment.webservice, rpcMethod);

  }
  
}